module.exports = __webpack_public_path__ + "img/cxwk.3fa924da.png";